module.exports = __webpack_public_path__ + "img/logoempresa.1182daaf.png";